import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod } from "../../../../services/httpService";
import messagePopup from "../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  PAYMENT_CARD_LIST_START: "PAYMENT_CARD_LIST_START",
  PAYMENT_CARD_LIST_FAIL: "PAYMENT_CARD_LIST_FAIL",
  PAYMENT_CARD_LIST_SUCCESS: "PAYMENT_CARD_LIST_SUCCESS",
};

// ============================================ Actions ========================================================

export const paymentCardListStart = (data) => ({
  type: actionType.PAYMENT_CARD_LIST_START,
  payload: data,
});

export const paymentCardListFail = (data) => ({
  type: actionType.PAYMENT_CARD_LIST_FAIL,
  payload: data,
});

export const paymentCardListSuccess = (data) => ({
  type: actionType.PAYMENT_CARD_LIST_SUCCESS,
  payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null,
};

export default function paymentCardListReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.PAYMENT_CARD_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case actionType.PAYMENT_CARD_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case actionType.PAYMENT_CARD_LIST_FAIL:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* paymentCardListSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
      yield put(
        paymentCardListSuccess(response.data.data.allCarddetails.Carddetails)
      );
    } else {
      messagePopup("", "Payment Card List failed", "error");
      yield put(paymentCardListFail("Payment Card List failed"));
    }
  } catch (error) {
    messagePopup("", "Payment Card List failed", "error");
    yield put(paymentCardListFail("Payment Card List failed"));
  }
}

export function* watchPaymentCardListSaga() {
  yield takeEvery(actionType.PAYMENT_CARD_LIST_START, paymentCardListSaga);
}
